
import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { RecordIdentifier } from "@/data/global";
import { CoursesFilterEvent } from "@/data/eventbus";
import EventBusService from "@/services/EventBusService";

interface SelectOption {
    value: RecordIdentifier,
    label: string,
}

@Options({
    props: {
        courseTypes: {
            type: Array as PropType<Array<SelectOption>>,
            required: true,
        },
        locations: {
            type: Array as PropType<Array<SelectOption>>,
            required: true,
        },
        currentCourseCount: {
            type: [Number, null] as PropType<number|null>,
            required: false,
            default: null,
        },
    },
    components: {

    },
    watch: {
        courseTypeSelection: 'filterChanged',
        locationSelection: 'filterChanged',
    }
})
export default class CourseFilter extends Vue {
    courseTypes!: Array<SelectOption>
    locations!: Array<SelectOption>

    currentCourseCount!: number|null

    courseTypeSelection: RecordIdentifier|null = null
    locationSelection: RecordIdentifier|null = null

    get visible(): boolean {
        return (this.locations && this.locations.length > 0) || (this.courseTypes && this.courseTypes.length > 0);
    }

    filterChanged(): void {
        EventBusService.$emit('region.courses.filter:changed', { // @TODO: not sure about the naming, as the component could be used in another context than "region"
            ...(this.courseTypeSelection ? {courseType: this.courseTypeSelection} : {}),
            ...(this.locationSelection ? {location: this.locationSelection} : {}),
        });
    }

    handleExternalChange(event: CoursesFilterEvent): void {
        // Setting the new values causes a recursive behaviour because of the watchers,
        // but as we only assign/change the variables when different, it quickly comes to a stop.

        if( typeof event.courseType !== 'undefined' && this.courseTypeSelection !== event.courseType ) {
            this.courseTypeSelection = event.courseType;
        }
        else if( typeof event.courseType === 'undefined' && this.courseTypeSelection !== null ) {
            this.courseTypeSelection = null;
        }

        if( typeof event.location !== 'undefined' && this.locationSelection !== event.location ) {
            this.locationSelection = event.location;
        }
        else if( typeof event.location === 'undefined' && this.locationSelection !== null ) {
            this.locationSelection = null;
        }
    }

    get resetVisible(): boolean {
        return !!this.courseTypeSelection || !!this.locationSelection;
    }

    reset(): void {
        this.courseTypeSelection = null;
        this.locationSelection = null;
    }

    mounted() {
        EventBusService.$on('region.courses.filter:changed', this.handleExternalChange);
    }
    beforeUnmount() {
        EventBusService.$off('region.courses.filter:changed', this.handleExternalChange);
    }
}
